import { render, staticRenderFns } from "./TabPrompts.vue?vue&type=template&id=6b39383c&scoped=true"
import script from "./TabPrompts.vue?vue&type=script&lang=js"
export * from "./TabPrompts.vue?vue&type=script&lang=js"
import style0 from "./TabPrompts.vue?vue&type=style&index=0&id=6b39383c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b39383c",
  null
  
)

export default component.exports